import { useQueryClient, useMutation } from "@tanstack/react-query"
import { fetcher } from "../fetcher"

type AccountLinkResponse = {
  linkToken: string
  expiration: string
  tokenId: string
}
type MutationFnParams = {
  verificationId: string
}

export function useAccountLinkToken() {
  const queryClient = useQueryClient()

  return useMutation<AccountLinkResponse, unknown, MutationFnParams>({
    mutationFn: async ({ verificationId }) => {
      const response = await fetcher("/Account/LinkToken", {
        method: "POST",
        body: JSON.stringify({
          verificationId,
        }),
      })
      const responseJson = await response.json()

      return responseJson
    },
    onSuccess: (response) => {
      queryClient.setQueryData(["AccountLinkToken"], response)
    },
  })
}
